import { AiOutlineCheck } from "react-icons/ai";
import { IBenefitTile } from "../../interfaces/api";

const BenefitItem = ({ benefit }: { benefit: IBenefitTile }) => {
  return (
    <div
      className="small-6 flex-container align-middle"
      style={{ padding: "5px 0" }}
    >
      <div
        style={{
          color: "#215732",
          display: "flex",
          alignItems: "center",
          paddingRight: "10px",
        }}
      >
        <AiOutlineCheck />
      </div>
      <span>{benefit.label}</span>
    </div>
  );
};

export default BenefitItem;
